"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SksgV2FirmwareUpdateCommandValidation = void 0;
class SksgV2FirmwareUpdateCommandValidation {
    static isValid(entity) {
        // If entity.location exists, validate that it has the correct type.
        if (entity.location != undefined) {
            if (typeof entity.location !== "string")
                return false;
        }
        // If entity.is_secc exists, validate that it has the correct type.
        if (entity.is_secc != undefined) {
            if (typeof entity.is_secc !== "boolean")
                return false;
        }
        return true;
    }
}
exports.SksgV2FirmwareUpdateCommandValidation = SksgV2FirmwareUpdateCommandValidation;
